import { Router } from '@angular/router';
import { AuthService } from '../auth.service';
var AuthGuard = /** @class */ (function () {
    function AuthGuard(router, authService) {
        this.router = router;
        this.authService = authService;
    }
    AuthGuard.prototype.canActivate = function () {
        if (this.authService.token && this.authService.roles.indexOf("administrador") > -1) {
            // logged in so return true
            return true;
        }
        // not logged in so redirect to login page
        this.router.navigate(['/login']);
        return false;
    };
    AuthGuard.ctorParameters = function () { return [{ type: Router }, { type: AuthService }]; };
    return AuthGuard;
}());
export { AuthGuard };
//# sourceMappingURL=auth-guard.js.map


// WEBPACK FOOTER //
// auth-guard.js